import { useId } from "react";
import { theme } from "../theme";

// ── Rankio značka (bez nápisu) ────────────────────────────────────────────────
// Ručně přepsané z src/assets/rankio-mark.svg. Přechody jsou svislé
// (v originále x1 === x2), takže jsou tu bez původní gradientTransform.
// ID přechodů musí být unikátní na stránku — logo se renderuje i vícekrát.
const STOPS = [
  [0, "#e6efff"], [0.01, "#d8e6ff"], [0.06, "#afcdfe"], [0.11, "#89b6fd"],
  [0.16, "#69a2fd"], [0.23, "#4d91fc"], [0.29, "#3784fc"], [0.37, "#267afb"],
  [0.47, "#1b72fb"], [0.61, "#146efb"], [1, "#126dfb"],
];

const Grad = ({ id, y1, y2 }) => (
  <linearGradient id={id} x1="0" y1={y1} x2="0" y2={y2} gradientUnits="userSpaceOnUse">
    {STOPS.map(([offset, color]) => <stop key={offset} offset={offset} stopColor={color} />)}
  </linearGradient>
);

export default function RankioMark({ height = 34, title = "Rankio", ...rest }) {
  const uid = useId().replace(/:/g, "");
  const [a, b, c] = [`${uid}a`, `${uid}b`, `${uid}c`];
  return (
    <svg
      height={height}
      viewBox="0 0 46.78 53.7"
      fill="none"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", flexShrink: 0 }}
      {...rest}
    >
      <defs>
        <Grad id={a} y1="53.52" y2="26.27" />
        <Grad id={b} y1="53.69" y2="14.39" />
        <Grad id={c} y1="53.7" y2="11" />
      </defs>
      <path d="M9.66,27.64l2.28-1.37V53.52h0C5.35,53.52,0,49,0,43.46H0C0,37.18,3.6,31.29,9.66,27.64Z" fill={`url(#${a})`} />
      <polygon points="16.03 22.81 28.33 14.39 27.97 53.69 16.03 53.69 16.03 22.81" fill={`url(#${b})`} />
      <path d="M31.78,11h12l-.13,32.64c-.06,5.57-5.44,10.06-12,10.06h0Z" fill={`url(#${c})`} />
      <polygon points="28.78 11 46.78 11 37.78 0 28.78 11" fill={theme.blue} />
    </svg>
  );
}
